<div class="w-full mb-6">
    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
        {{ label() ?? 'Upload Image(s)' }}
    </label>
    @if (subTitle()) {
    <p class="text-xs text-primary-300 block">{{ subTitle() }}</p>
    }
    <p class="text-xs text-primary-300">Image file(s) up to 5 Mb only</p>
    <div class="flex flex-row gap-4 mt-2 w-full">
        <div class="rounded h-[250px] grow">
            <uppy-dashboard [uppy]="uppy" [props]="dashboardProps"></uppy-dashboard>
        </div>
    </div>
</div>